import rootSaga from './root';
import middleware from './middleware';

export default function start() {
  middleware.run(rootSaga);
}
